/*
  LNB 메뉴 리스트
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import storage from 'helpers/storage';

const propTypes = {};

const defaultProps = {};

class Menu extends Component {
  constructor(props) {
    super(props);
  }

  // 별 노란색으로~
  starMouseOver = (e) => {
    e.target.className = 'yellow star small icon';
  };

  // 별 회색으로~
  startMouserOut = (e) => {
    e.target.className = 'grey star small icon';
  };

  render() {
    const { listResult } = this.props;
    const { bookMarkAdd, lnbMenuClick } = this.props.lnbMenuFn;
    const comInfo = storage.get('company').info;
    const companyId = storage.get('company').id;
    const { isApproval, id: userId } = storage.get('company').user; // 청구서 권한
    const isOurHome = storage.get('companyInfo').useOurHomePoint; // 아워홈포인트 사용여부
    // const isSettlement = storage.get('isSettlement').user.isSettlement;   //사용자 정산관리 권한
    // LNB depth2 에서 벤디스와 제품본부 라이브는 모든 메뉴를 볼 수 있어야 함
    const vendysComId = companyId !== 'B068366F-5EB8-1C7E-E79C-D438C8E32F9D'; // 벤디스
    const productComId = companyId !== 'BF94DFBE-B085-44A1-8910-788C310CF2DD'; // 제품본부 Live
    // LNB 메뉴 소메뉴(depth2)
    const depth2 = this.props.depth2.map((menu, idx) => {
      if (menu.visibleCompanyIds && !menu.visibleCompanyIds.includes(companyId)) {
        return null;
      }
      if (menu.url === '/main/MyPointList' && !comInfo.useMypoint) {
        return null;
      }
      if (menu.url === '/main/mealApproveList' && !comInfo.useDemand) {
        return null;
      }
      if (menu.url === '/main/settlementList' && !comInfo.isSettlement) {
        return null;
      }
      if (menu.url === '/main/staffManagementMeal' && !comInfo.isBudget) {
        return null;
      }
      if (menu.url === '/main/bill' && !comInfo.isInvoice) {
        return null;
      }
      if (menu.url === '/main/accountManagement' && !comInfo.isAdminAuth) {
        return null;
      }
      if ((menu.url === '/main/bookingStatus' || menu.url === '/main/bookingStats') && !comInfo.isBooking) {
        return null;
      }
      if (menu.url === '/main/paymentReason' && !comInfo.isPaymentReason) {
        return null;
      }
      if (menu.url === '/main/ourhomeSubtractStat' && !isOurHome) {
        return null;
      }
      if (
        menu.url === '/main/salary-deduction' &&
        vendysComId &&
        productComId &&
        companyId !== '46BD447A-6652-4BAA-A97F-2079AD44986F' // 삼성카드
      ) {
        return null;
      }
      if (
        menu.url === '/main/salary-deduction-cnt' &&
        vendysComId &&
        productComId &&
        companyId !== 'F5E70FD2-10FE-431E-A9D9-19A4F70C742F' && // 삼성물산
        companyId !== '2BA41B58-8716-464E-A2A3-ECB9FC974528' && // 웰컴시스템아이엔씨
        companyId !== 'F5F45C99-C85E-4B2A-9A66-2BE7B18BE1C4' && // 삼성물산_테스트(3.0) 계정
        companyId !== '64667880-2B25-4EB2-8FF0-9F5129F15925' // 웰컴시스템아이엔씨 테스트 계정
      ) {
        return null;
      }
      if (
        menu.url === '/main/salary-deduction-medical' &&
        vendysComId &&
        productComId &&
        companyId !== '3B4C26BD-FA26-4584-AE29-350E697E6FB5' && // 삼성의료재단 Live
        companyId !== 'EAC9A7CC-6747-4B74-8339-8AFF2FAE44D9' // 삼성의료재단 테스트 계정
      ) {
        return null;
      }
      if (
        menu.url === '/main/salary-deduction-kimandchang' &&
        vendysComId &&
        productComId &&
        companyId !== '9731FC1F-7A18-4B97-BFEC-6DA79DFAE289' && // 김앤장 Live
        companyId !== '8560C2A1-0A40-496E-B865-D7FA6C0D35B9' && // 김앤장 테스트 계정
        companyId !== '13CB2F3C-F28E-40A4-82E4-C904656D1AE1' // 주식회사 망곰베어스 테스트
      ) {
        return null;
      }
      let isBookMark = false;
      if (listResult && listResult.data && listResult.data.favorite) {
        listResult.data.favorite.forEach((data) => {
          if (menu.code == data.code) {
            isBookMark = true;
          }
        });
      }

      const url = this.context.router.history.location.pathname;
      const isActive = menu.url === url;

      // invoice:view(청구서 조회)권한은 없지만 isApproval(청구서 소유여부)가 존재한 경우 노출
      if (menu.url === '/main/bill' && !menu.isShow && isApproval) {
        menu.isShow = true;
      }
      return menu.isShow ? (
        <li className={isActive ? 'menu-active' : ''} key={menu.code} style={{ textAlign: 'left' }}>
          <div
            onClick={(e) => {
              lnbMenuClick(menu);
            }}
          >
            <a>{menu.name}</a>
          </div>
          <Icon
            name="star"
            size="small"
            color={isBookMark ? 'green' : 'grey'}
            onClick={() => bookMarkAdd(menu.code, isBookMark)}
            style={{ float: 'right', margin: '18px' }}
          />
        </li>
      ) : null;
    });

    return <ul>{depth2}</ul>;
  }
}

Menu.contextTypes = {
  router: PropTypes.object.isRequired
};

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

Menu = connect((state) => ({
  listResult: state.bookMark.listResult
}))(Menu);

export default Menu;
